module.exports = __webpack_public_path__ + "static/media/Website Mockup _V6.b96f733b.jpg";